import { GridCellProps } from '@progress/kendo-react-grid';
import { useInternationalization } from '@progress/kendo-react-intl';
import { validateNumber } from 'src/assets/static/view_checkbook/useCheckbookPeriodColumns';
import GridCellBase from 'src/components/GridCellBase';
import useDebounce from 'src/hooks/useDebounce';

const SpentAmountDollarCell = (props: GridCellProps) => {
  const { dataItem, field = '' } = props;
  const { newAmount, card } = dataItem;
  const intl = useInternationalization();
  const debouncedNewAmount = useDebounce(newAmount, 1000);

  let finalOp: number = Number(dataItem[field]);

  return (
    <GridCellBase
      {...props}
      title={String(finalOp)}
      rowSelectionEnabled
      style={{
        ...validateNumber(field, dataItem),
        textAlign: 'right',
      }}
    >
      <span>
        {intl.format(
          '{0:c2}',
          card === 'add'
            ? Number(finalOp) - Number(debouncedNewAmount)
            : Number(finalOp) + Number(debouncedNewAmount)
        )}
      </span>
    </GridCellBase>
  );
};

export default SpentAmountDollarCell;
